import React from 'react'

function Linkedin2Icon() {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="rgba(57, 61, 99, 1)"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.82498 5.02829H2.79112C1.09782 5.02829 0 3.92046 0 2.5162C0 1.08461 1.13027 0 2.85744 0C4.58319 0 5.64432 1.08188 5.67819 2.5121C5.67819 3.91636 4.58319 5.02829 2.82498 5.02829ZM24.001 21.3328H18.6968V13.8334C18.6968 11.8705 17.8671 10.5304 16.0426 10.5304C14.647 10.5304 13.8709 11.4347 13.5097 12.3062C13.3904 12.5816 13.3925 12.9524 13.3948 13.3345C13.3951 13.3864 13.3954 13.4385 13.3954 13.4905V21.3328H8.1405C8.1405 21.3328 8.20824 8.04835 8.1405 6.8408H13.3954V9.11521C13.7058 8.12075 15.385 6.70146 18.0646 6.70146C21.3891 6.70146 24.001 8.786 24.001 13.2747V21.3328ZM5.28397 6.84209H0.606241V21.3341H5.28397V6.84209Z"
      />
    </svg>
  )
}

export default Linkedin2Icon
